<template>
  <section class="bloc-images-links">
    <router-link v-if="content.link_one" class="bloc-images-links__link scroll-step js-scroll-show" :to="content.link_one.url">
      <img class="img" :src="require(`@/${content.link_one.img}`)">
      <div class="overlay" />
      <span class="title" v-html="content.link_one.text" />
    </router-link>
     <router-link v-if="content.link_two" class="bloc-images-links__link scroll-step js-scroll-show show-delay-100" :to="content.link_two.url">
      <img class="img" :src="require(`@/${content.link_two.img}`)">
      <div class="overlay" />
      <span class="title" v-html="content.link_two.text" />
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'MainText',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-images-links {
    width: 100vw;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @include media($from: small) {
      flex-direction: row;
    }

    &__link {
      position: relative;
      width: 100%;
      height: grid(6, 7);
      display: flex;
      align-items: center;

      @include media($from: small) {
        width: 50%;
      }

      &:hover {
        .overlay {
          opacity: 1;
        }
      }

      .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .title {
        @include paragraph($type: 'extrabig-gotham', $color: $th-white, $uppercase: true);
        position: absolute;
        left: 0;
        width: 100%;
        padding: 0 rem(50);
        z-index: 1;
        text-align: center;

        @include media($from: small) {
          top: rem(100);
        }
      }

      .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: $th-cherry, $alpha: 0.5);
        opacity: 0;
        transition: opacity 0.3s $quad-ease-out;
      }
    }
  }
</style>
